import { IPatientDetail } from "@curefit/care-common";

export class ConsentParam {
    public principleReferenceEntity: string;
    public ownerReferenceEntity: string;
    public ownerReferenceEntityId: string;
    public resourceType: string;
    public principleReferenceEntityId: string;
    public action: string;
    public consentType: string;

    constructor(patient: IPatientDetail, action?: "EDIT", consentType?: "USER") {
        this.principleReferenceEntity = "CF_USER";
        this.ownerReferenceEntity = "PATIENT";
        this.ownerReferenceEntityId = patient.id.toString();
        this.resourceType = "CONSULTATION";
        this.principleReferenceEntityId = patient.curefitUserId;
        this.action = action;
        this.consentType = consentType;
    }

}